import { SysConfigApp } from '@/config'

import { crud } from './_crud'

/** 会员管理 */
export default {
  body: {
    type: 'page-tabs',
    items: [
      { label: '兔哒力', body: crud(SysConfigApp.TDL) }
      // { label: '系统', body: crud(SysConfigType.SYS) }
    ]
  }
}
